import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CarriageRules from './CarriageRules';
import AddCarriageRule from './AddCarriageRule';
import EditCarriageRule from './EditCarriageRule';
import ClosingRules from './ClosingRules';
import AddClosingRule from './AddClosingRule';
import EditClosingRule from './EditClosingRule';
import RulesLayout from './RulesLayout';

const Rules = () => {
  console.log('Rendering Rules Component');

  return (
    <RulesLayout>
      <Routes>
        <Route path="/" element={
          <div>
            <h1>Rules</h1>
            <p>Define and manage rules for both carriage (pre and on carriage) and closing dates.</p>
          </div>
        } />
        <Route path="carriage" element={<CarriageRules />} />
        <Route path="carriage/add" element={<AddCarriageRule />} />
        <Route path="carriage/edit/:id" element={<EditCarriageRule />} />
        <Route path="closing" element={<ClosingRules />} />
        <Route path="closing/add" element={<AddClosingRule />} />
        <Route path="closing/edit/:id" element={<EditClosingRule />} />
      </Routes>
    </RulesLayout>
  );
};

export default Rules;
